// HustlrMate's own streak mark, drawn here rather than taken from an icon set. Two tips, one
// fire: a streak here is kept by two people. The check at its core is the day you showed up,
// so an unlit mark (`lit={false}`, no streak yet) is the hollow flame without it.
// Sized and coloured like any other icon: `className="w-4 h-4 text-[#F59E0B]"`.
const FLAME = "M12 21.5C8.1 21.5 5 18.6 5 14.8c0-3 1.8-4.9 3.2-7C9.3 6.2 10 4.4 9.8 2.5c2.6 1.4 4.4 3.9 4.8 6.9.1.8-.1 1.6-.4 2.3 1.3-.7 2.3-1.9 2.9-3.3C18.3 10.2 19 12.3 19 14.8c0 3.8-3.1 6.7-7 6.7z";
const CHECK = "M9.2 15.3l2.1 2.1 3.7-4";

export default function StreakIcon({ className = "", strokeWidth = 1.5, lit = true, title, ...rest }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      {...rest}
    >
      {title && <title>{title}</title>}
      <path d={FLAME} fill={lit ? "currentColor" : "none"} fillOpacity={lit ? 0.18 : undefined} />
      {lit && <path d={CHECK} />}
    </svg>
  );
}
